(() => {
	const initDisclosures = (root) => {
		root.querySelectorAll('[data-gss-toggle]').forEach((button) => {
			if (button.dataset.gssToggleInit) return;
			button.dataset.gssToggleInit = 'true';

			button.addEventListener('click', () => {
				const wrapper = button.closest('.gss-tag-tabs__grid-wrapper');
				if (!wrapper) return;

				const expanded = wrapper.dataset.expanded === 'true';
				wrapper.dataset.expanded = expanded ? 'false' : 'true';
				button.setAttribute('aria-expanded', expanded ? 'false' : 'true');

				wrapper.querySelectorAll('[data-gss-extra]').forEach((item) => {
					if (expanded) {
						item.setAttribute('hidden', '');
					} else {
						item.removeAttribute('hidden');
					}
				});
			});
		});
	};

	const initTabs = (root) => {
		if (root.dataset.gssTagTabsInit) return;
		root.dataset.gssTagTabsInit = 'true';

		const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
		if (!tabs.length) return;

		const activate = (tab, { focus = false } = {}) => {
			tabs.forEach((t) => {
				const selected = t === tab;
				t.classList.toggle('active', selected);
				t.setAttribute('aria-selected', selected ? 'true' : 'false');
				t.setAttribute('tabindex', selected ? '0' : '-1');

				const panel = root.querySelector(`#${t.getAttribute('aria-controls')}`);
				if (!panel) return;
				panel.classList.toggle('active', selected);
				if (selected) {
					panel.removeAttribute('hidden');
				} else {
					panel.setAttribute('hidden', '');
				}
			});
			if (focus) tab.focus();
		};

		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => activate(tab));

			tab.addEventListener('keydown', (event) => {
				let newIndex = null;

				switch (event.key) {
					case 'ArrowRight':
					case 'ArrowDown':
						newIndex = (index + 1) % tabs.length;
						break;
					case 'ArrowLeft':
					case 'ArrowUp':
						newIndex = (index - 1 + tabs.length) % tabs.length;
						break;
					case 'Home':
						newIndex = 0;
						break;
					case 'End':
						newIndex = tabs.length - 1;
						break;
					default:
						return;
				}

				event.preventDefault();
				activate(tabs[newIndex], { focus: true });
			});
		});
	};

	const init = (root) => {
		initTabs(root);
		initDisclosures(root);
	};

	const initAll = () => {
		document.querySelectorAll('.gss-tag-tabs').forEach(init);
	};

	document.addEventListener('DOMContentLoaded', initAll);
	document.addEventListener('shopify:section:load', (event) => {
		const root = event.target.querySelector('.gss-tag-tabs');
		if (root) init(root);
	});
})();
